import { useState, useEffect } from 'react'

// eslint-disable-next-line import/prefer-default-export
export const useRecaptchaHook = (
  recaptchaSiteKey: string,
  recaptchaAction = 'homepage',
  initOnload = false
) => {
  const [recaptchaToken, setRecaptchaToken] = useState('')

  useEffect(() => {
    if (
      recaptchaToken ||
      !process.browser ||
      !initOnload ||
      typeof window.grecaptcha === 'undefined'
    ) {
      return
    }

    const { grecaptcha } = window
    grecaptcha.ready(async () => {
      const action = { action: recaptchaAction }
      console.log('recaptchaAction: ', action)
      const token = await grecaptcha.execute(recaptchaSiteKey, action)
      setRecaptchaToken(token)
    })
  }, [recaptchaAction, recaptchaSiteKey, recaptchaToken])

  const executeReCaptcha = async (action?: string): Promise<string> => {
    if (!process.browser || typeof window.grecaptcha === 'undefined') {
      return ''
    }

    return new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        console.log('recaptchaAction: ', action)
        window.grecaptcha
          .execute(recaptchaSiteKey, { action })
          // @ts-ignore
          .then((token) => resolve(token))
      })
    })
  }
  return { executeReCaptcha, recaptchaToken }
}
